// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { i18n } from './lang/lang'
import router from './router'
import VueCookies from 'vue-cookies'
import VueResource from 'vue-resource'
import VeeValidate from 'vee-validate'
import BootstrapVue from 'bootstrap-vue'
import * as svgicon from 'vue-svgicon'
import GAuth from 'vue-google-oauth2'
import bugsnag from 'bugsnag-js'
import bugsnagVue from 'bugsnag-vue'
import VueNotifications from 'vue-notifications'
import iziToast from 'izitoast'

import 'normalize.scss/normalize.scss'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'izitoast/dist/css/iziToast.css'
import '../assets/scss/global.scss'

function toast ({title, message, type, timeout, cb}) {
  if (type === VueNotifications.types.warn) type = 'warning'
  iziToast.settings({
    position: 'bottomLeft',
    timeout: false,
    closeOnClick: true,
    progressBar: false,
    close: true
  })
  return iziToast[type]({title, message})
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

Vue.use(VueNotifications, options)
const bugsnagClient = bugsnag(process.env.BUGSNAG_KEY)
bugsnagClient.use(bugsnagVue(Vue))

const validateConfig = {
  locale: i18n.locale,
  i18n: null, // the vue-i18n plugin instance,
  i18nRootKey: 'custom' // the nested key under which the validation messsages will be located
}

Vue.use(VueCookies)
Vue.use(VueResource)
Vue.use(VeeValidate, validateConfig)
Vue.use(BootstrapVue)
Vue.use(svgicon, {
  tagName: 'svgicon'
})

Vue.use(GAuth, {
  clientId: process.env.GOOGLE_CLIENT_ID,
  scope: 'profile email https://www.googleapis.com/auth/plus.login https://www.googleapis.com/auth/user.phonenumbers.read'
})

// Vue.use(GoogleAuth, { client_id: process.env.GOOGLE_CLIENT_ID })
// Vue.googleAuth().load()
// Vue.googleAuth().directAccess()
// Vue.use(VueIziToast);

Vue.http.options.root = `${process.env.API_URL}`
Vue.config.productionTip = false

/* eslint-disable no-new */
export const app = new Vue({
  el: '#app',
  i18n,
  router: router.router,
  template: '<App/>',
  components: { App }
})

window['vue'] = app



// WEBPACK FOOTER //
// ./src/main.js